<template>
  <div class="container" v-loading="loading" element-loading-text="页面中转，请稍后" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"></div>
</template>

<script>
import axios from "axios";
import urlSet from "@/api/baseurl.js";
export default {
  data() {
    return {
      loading: true,
      user_id: "",
      user_name: "",
      timestamp: "",
      sign: "",
    };
  },
  created() {
    // 使用两种方式获取参数，确保参数能正确获取
    // 方式1: 使用Vue Router的query获取参数
    // 添加decodeURIComponent处理中文参数
    this.user_id = this.$route.query.user_id ? decodeURIComponent(this.$route.query.user_id) : "";
    this.user_name = this.$route.query.user_name ? decodeURIComponent(this.$route.query.user_name) : "";
    this.timestamp = this.$route.query.timestamp ? decodeURIComponent(this.$route.query.timestamp) : "";
    this.sign = this.$route.query.sign ? decodeURIComponent(this.$route.query.sign) : "";
  },
  mounted() {
    this.schoolLogin();
  },
  methods: {
    schoolLogin() {
      this.loading = true;
      this.$http({
        url: `${urlSet.baseUrl}api/v1/hall/zxy`,
        method: "POST",
        data: {
          user_id: this.user_id,
          user_name: this.user_name,
          timestamp: this.timestamp,
          sign: this.sign,
        },
      })
        .then(res => {
          if (res && res.data) {
            localStorage.setItem("jyx_token", res.data);
            this.$message.success("登录成功");
            setTimeout(() => {
              this.loading = false;
              this.getMineInfo();
              this.getInfo();
            }, 800);
          } else {
            this.$message.error("登录失败");
            // 延迟返回，让用户有时间看到错误提示
            setTimeout(() => {
              this.$router.go(-1);
            }, 1500);
          }
        })
        .catch(error => {
          // 关键修复：添加catch错误处理
          this.loading = false;
          this.$message.error("登录失败：网络错误");
          console.error("登录请求错误:", error);
          // 延迟返回，让用户有时间看到错误提示
          setTimeout(() => {
            this.$router.go(-1);
          }, 1500);
        });
    },
    getMineInfo() {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        this.$store.commit("getUserName", res.data.userName);
        localStorage.setItem("userName", res.data.userName);
        location.href = `/articleSearch`;
      });
    },
    getInfo() {
      this.$http({
        url: "api/v1/user/getInfo",
        method: "GET",
      }).then(res => {
        let str = res.data.roles.toString();
        localStorage.setItem("roles", str);
      });
    },
  },
};
</script>

<style scoped>
.container {
  min-width: calc(100vw);
  min-height: calc(100vh);
}
</style>
